import { createSelector } from 'reselect';
import { RootState } from 'types/root-state';
import { range } from 'utils';
import { MOBILE_VIEW_SEARCH_PARAM } from '../constants';

export const getSearch = createSelector(
	({ router }: RootState) => router?.search,
	search => search
);

export const selectIsMobileView = createSelector(getSearch, search =>
	search?.includes(MOBILE_VIEW_SEARCH_PARAM)
);

export const getPath = createSelector(
	({ router }: RootState) => router,
	router => router.path
);

export const getHost = ({ host }: RootState) => host;

export const getBaseUrl = createSelector(
	getHost,
	getPath,
	(host, pathname) => `https://${host}${pathname}`
);

export const getHostname = createSelector(getHost, host => host.replace(/:[0-9]+/, ''));

export const getDomain = createSelector(getHostname, hostname => {
	let result = '';

	const localhost = 'localhost';
	const separator = '.';
	const start = hostname.indexOf(separator);

	const isIpAddress = /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/g.test(
		hostname
	);

	if (isIpAddress) {
		return hostname;
	}

	if (hostname.endsWith(localhost)) {
		const splitted = hostname.split('.');

		return splitted[splitted.length - 1];
	}

	if (start !== -1) {
		const split = hostname.split(separator);

		result = hostname
			.split(separator)
			.slice(split.length - 2)
			.join(separator);
	}

	return result;
});

export const getRegionDomain = createSelector(getHostname, getDomain, (hostname, domain) => {
	const allFsStands = range(20).map(index => `fs${index}`);
	const definitelyNotARegion = [
		...allFsStands,
		'ux',
		'aem-pprod',
		'aem',
		'localhost',
		'leroymerlin',
		'lemanapro',
		'isomorphic-shared-stage',
	];

	if (
		[
			'adeo.com',
			'leroymerlin.ru',
			'lemanapro.ru',
			'lemanapro.kz',
			'localhost',
			'lmru.tech',
		].some(matchingDomain => domain === matchingDomain)
	) {
		const [maybeRegion] = hostname.split('.');
		if (maybeRegion.indexOf('triffle') >= 0) {
			return '';
		}
		if (!definitelyNotARegion.includes(maybeRegion)) {
			return maybeRegion;
		}
	}

	return '';
});
